import Timestamp from "components/Timestamp";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { WebhookIntegrationWithTimestamp } from "../types";

const ModuleWebhooksTableTimestampCell = ({
  item: webhook,
  ...cellProps
}: TableSimpleCellProps<WebhookIntegrationWithTimestamp>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <Timestamp timestamp={webhook.createdAt} variant="p-body3" />
    </TableSimpleCell>
  );
};

export default ModuleWebhooksTableTimestampCell;
